<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :show-close="false"
    center
    width="90%"
    :top="'2vh'"
  >
    <dialog-header
      slot="title"
      :title="!isEdit? $t('public.create'):$t('public.update')"
      :icon="!isEdit? 'icon-dialog-add':'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle style="padding-top:10px">
        <el-form ref="form" size="mini" :model="formInfo" :rules="rules" :label-position="'right'" 
          :label-width="$t('system.pdpa.labelWidth2')">
            <el-form-item :label="$t('system.pdpa.appName') + '：'"  prop="appType" required>
              <el-radio-group v-model="formInfo.appType">
                <el-radio :label="0">
                  {{ $t('system.pdpa.v2x') }}
                </el-radio>
                <el-radio :label="1">
                  {{ $t('system.pdpa.playconnect') }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('system.pdpa.version') + '：'">
              <!-- {{version}} -->
              <el-input v-model="formInfo.version" :maxlength="50" :placeholder="$t('system.pdpa.version')" clearable  />
            </el-form-item>
            <!-- <el-form-item :label="$t('system.pdpa.typeSelect') + '：'" prop="effectiveDate" required>
              <el-date-picker
                v-model="formInfo.effectiveDate"
                type="date"
                :placeholder="$t('system.pdpa.typeSelect')">
              </el-date-picker>
            </el-form-item> -->
          </el-form>
          <el-row type="flex" :gutter="10">
            <el-col :span="12">
              <h3>泰文：</h3>
              <div class="wang-editor—wrapper">
                <Toolbar
                    class="wang-toolbar-container"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                />
                <Editor
                    class="wang-editor-container"
                    v-model="html"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="onCreated"
                />
              </div>
            </el-col>
            <el-col :span="12">
              <h3>英文：</h3>
              <div class="wang-editor—wrapper">
                <Toolbar
                    class="wang-toolbar-container"
                    :editor="editor1"
                    :defaultConfig="toolbarConfig1"
                    :mode="mode1"
                />
                <Editor
                    class="wang-editor-container"
                    v-model="html1"
                    :defaultConfig="editorConfig1"
                    :mode="mode1"
                    @onCreated="onCreated1"
                />
              </div>
            </el-col>
          </el-row>
          
    </vue-linetitle>
    <div style="height:8px"></div>
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handlecancle">{{$t('public.cancel')}}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{$t('public.define')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
// css
import '@wangeditor/editor/dist/css/style.css' // 引入 css
// request
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
// import { i18nGetResources  } from '@wangeditor/editor'
import { getAdd, getUpdate } from '@/api/system/pdpa'
// 混入
import { partialForm } from '@/mixins/partialForm'
export default {
  name: 'AddUpdateDialog',
  components: { Editor, Toolbar },
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    mobile: {
      type: String,
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    }
  },
  data() {
    const appType = (rule, value, cb) => {
      if (value != 0 && value != 1) {
        return cb(new Error(this.$t('system.pdpa.appTypemsg')))
      }
    }
    
    // const effectiveDate = (rule, value, cb) => {
    //   if (!value) {
    //     return cb(new Error(this.$t('system.pdpa.effectiveDatemsg')))
    //   }
    // }
 
    return {
      formInfo: {},
      version:'1.0.0',
      rules: {
        appType: [
          { required: true, trigger: ['blur','change'], validator: appType }
        ],
        // effectiveDate: [
        //   { required: true, trigger: ['blur','change'], validator: effectiveDate }
        // ]
      },
      editor: null,
      html: '',
      toolbarConfig: {
        excludeKeys:['fullScreen']
      },
      editorConfig: { placeholder: '请输入内容...' },
      mode: 'default', // or 'simple'
      editor1: null,
      html1: '',
      toolbarConfig1: {
        excludeKeys:['fullScreen']
      },
      editorConfig1: { placeholder: '请输入内容...' },
      mode1: 'default', // or 'simple'
    }
  },
  watch: {
    visibles: {
      handler(e1) {
        if (e1) {
          // this.i18nGetResources('en')
          this.formInfo = {...this.data }
          this.html = ''
          this.html1 = ''
          if(this.isEdit){
            this.html = this.data.thContent
            this.html1 = this.data.enContent
          }
        }
      }
    }
  },
  created(){
  },
  methods: {
    // 关闭dialog
    closeDialog() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
      const editor1 = this.editor1
      if (editor1 == null) return
      editor1.destroy() // 组件销毁时，及时销毁编辑器
      this.formInfo = {}
      this.$emit('update:visibles', false)
    },
    // 点击取消
    handlecancle() {
        this.closeDialog()
    },
    onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onCreated1(editor) {
        this.editor1 = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    // 点击确定
    handleSubmit(){
      let check = this.checkForm({ formName: 'form',
          formList: ['appType'] })
      if(!check) return
      let apptypename = ''
      if(this.formInfo.appType == 0){
        apptypename = 'V2X-A2'
      }else if(this.formInfo.appType == 1){
        apptypename = 'PlayConnect'
      }
      // eslint-disable-next-line no-unused-vars
      const { appType, version } = this.formInfo
      var localhostPath = window.location.host
      let postData = {
        appType,version,
        thUrl:"http://"+localhostPath+`/#/toyotaAgreement?appType=${apptypename}&language=th`,
        enUrl:"http://"+localhostPath+`/#/toyotaAgreement?appType=${apptypename}&language=en`,
        thContent: this.html,
        enContent: this.html1
      }
      if(!this.isEdit){
        this._createUser(postData)
      }else{
        postData.id=this.formInfo.pdpaId
        this._updateUser(postData)
      }
          
    },
  
    // 新增
    _createUser(postData) {
      getAdd(postData).then(({ data }) => {
        if(data.code === 0) {
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    // 编辑
    _updateUser(postData) {
      getUpdate(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    }
  }
}
</script>
<style lang="scss">
.wang-editor—wrapper{
  border: 1px solid #ddd;
}
.wang-toolbar-container{
  border-bottom: 1px solid #ddd; 
  background-color: #eee;
  .w-e-bar{
    background: none;
  }
}
.wang-editor-container{
  height: calc(98vh - 390px); 
  overflow-y: hidden;
}
</style>
